import { useEffect, useState } from "react";
import type { SnapshotView } from "./public-daily-report-types";
import { readPublicDailyReport } from "./public-daily-report-gateway";

type SnapshotState = { token: string; data: SnapshotView | null; error: string };
const missingToken = "Bağlantıda rapor erişim anahtarı bulunmuyor.";
export function usePublicDailyReportSnapshot({token}: {token: string}) {
  const [state, setState] = useState<SnapshotState>({token, data: null, error: ""});
  useEffect(() => {
    const controller = new AbortController();
    setState({token, data: null, error: token ? "" : missingToken});
    if (token) void readPublicDailyReport(token, controller.signal).then(data => {
      if (!controller.signal.aborted) setState({token, data, error: ""});
    }).catch((reason: unknown) => {
      if (!controller.signal.aborted) setState({token, data: null, error: reason instanceof Error ? reason.message : "Rapor alınamadı."});
    });
    return () => controller.abort();
  }, [token]);
  const visible = state.token === token;
  return {data: visible ? state.data : null, error: !token ? missingToken : visible ? state.error : ""};
}
